module.exports = new __parcel__URL__("space_elixir_storage_level_10.8df3ab47.png").toString();